<template lang="pug">
the-instructions.ui-design.ui-design__layout
  modals-controller
  layout-header
  v-main(
    color="ui-background"
  )
    v-container.ui-design__container.fit-content-height.mt-7
      .ui-design__container.d-flex.flex-column.align-start.gap-12.mb-8(
        v-if="$route.meta && !($route.meta && $route.meta.hideMeta)"
      )
        v-expand-transition
          template(v-if="$route.meta.back")
            portal-target.d-contents(name="layout.meta-back")
              dv-btn(
                color="ui-neutral"
                text
                @click="$router.go(-1)"
              )
                v-icon.mr-2(:size="20") $ui-arrow-left
                p Назад
        v-expand-transition
          template(v-if="(breadcrumbs && breadcrumbs.length) || ($route.meta && $route.meta.isDynamicBreadcrumbs)")
            portal-target.d-contents(name="layout.meta-breadcrumbs")
              dv-breadcrumbs(
                v-if="breadcrumbs && breadcrumbs.length"
                :items="breadcrumbs"
              )
        portal-target.d-contents(
          v-if="$route.meta.title || $route.meta.isDynamicTitle"
          name="layout.meta-title"
        )
          h1.ui-h1.my-0.ui-neutral--text(
            v-if="$route.meta.title"
          ) {{ $route.meta.title }}
        v-expand-transition
          template(v-if="$route.meta.subtitle")
            portal-target.d-contents(name="layout.meta-subtitle")

      slot(v-bind="{ listeners }")

  portal-target(name="afterwrap")
</template>

<script>
// ! @TODO remove, currently used in some places | deprecated
import ModalsController from '@/components/layout/ModalsController/index.vue';
import LayoutHeader from '@/components/ui-design/layout/layout-header/LayoutHeader.vue';
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import DvBreadcrumbs from '@/packages/ui/components/breadcrumbs/DvBreadcrumbs.vue';
import TheInstructions from '@/components/layout/TheInstructions.vue';

export default {
  components: {
    LayoutHeader,
    DvBtn,
    DvBreadcrumbs,
    ModalsController,
    TheInstructions,
  },
  data() {
    return {
      listeners: {
        'set-breadcrumbs': this.setBreadcrumbs,
      },
      breadcrumbs: [],
    };
  },

  watch:{
    $route: {
      handler() {
        this.breadcrumbs = [];
      },
      immediate: true,
    },
  },

  methods: {
    setBreadcrumbs(value) {
      this.breadcrumbs = Array.isArray(value) ? value : [];
    },
  },
};

</script>

<style lang="scss">
@import '@/styles/scss/ui-styles.scss';

.v-main__wrap {
  display: flex;
  background-color: unset;
}

.ui-design__layout .v-main__wrap > .ui-design__container {
  min-width: 0;
}
</style>
